<template>
	<div class="login-box">
	  <div class="login-logo">
			<h1>Bienvenido a</h1> <img src="images/Logo_LaborTIME_Azul.png" alt="LaborTIME" style="width: 200px;" />
	  </div>
	  <!-- /.login-logo -->

		<!-- <div style="text-align: right;">
			<img src="images/Logo_SAISE_horizontal.png" alt="SAISE-IS" style="width: 80px; margin-top: 20px;" />
		</div> -->

	  <!-- /.login-box-body -->
	</div>
	<!-- /.login-box -->
</template>

<script>
    export default {
    	data() {
            return {
            	resource: {
	                email: null,
	                password: null,
	            },
                error: false
            }
        },
        methods: {
            signin(event) {
                event.preventDefault();
                this.$auth.signin(this, this.resource.email, this.resource.password);
            }
        }
    }
</script>